import * as autocomplete from '@varvet/tiny-autocomplete';

declare global {
    interface JQuery {
        tinyAutocomplete(arg: object): JQuery;
    }
}

export function GetDefaultAutocompleteSettings() {
    return {
        itemTemplate: '<li class="autocomplete-item">{{name}}</li>',
        method: 'post',
        maxItems: 30,
        queryProperty: "term",
        showNoResults: true,
        noResultsTemplate: '<li class="autocomplete-item">"{{title}}" kifejezésre nincs találat.</li>',
        url: '',
        minChars: 0,
        onSelect: function (el, val) { }
    }
}

export function CountrySettings(): object {
    var settings = GetDefaultAutocompleteSettings();
    settings.url = window.ETDR_RD.appConfig["UrlAction.AutoOrszag"];
    settings.minChars = 3;
    settings.onSelect = function (el, val) {
        $(this).val(val.name);
        $(this).attr('value', val.name);
        $(this).closest('table.form').find('input.country-id').attr('value', val.id);
    };

    return settings;
}

export function ZipcodeSettings(): object {
    let settings = GetDefaultAutocompleteSettings();
    settings.url = window.ETDR_RD.appConfig["UrlAction.AutoTelepulesFromZipCode"];
    settings.queryProperty = "zipCode";
    settings.minChars = 4;
    settings.onSelect = function (el, val) {
        let settlementNameElem: JQuery<HTMLElement> = $(this).closest('table.form');

        if (settlementNameElem.length > 0) {
            $(this).closest('table.form').find('input.settlement-name').val(val.name);
            $(this).closest('table.form').find('input.settlement-id').val(val.id).trigger('change');
        } else {
            $(this).closest('#generic-modal-form').find('input.settlement-name').val(val.name);
            $(this).closest('#generic-modal-form').find('input.settlement-id').val(val.id).trigger('change');
        }
    };

    return settings;
}

// KozteruletJelleg autocomplete
export function NatureOfPublicSpaceAutocompleteSettings(): object {
    let settings = GetDefaultAutocompleteSettings();
    settings.url = window.ETDR_RD.appConfig["UrlAction.AutoKozteruletJelleg"];
    settings.queryProperty = "term";
    settings.minChars = 2;
    settings.onSelect = function (el, val) {
        $(this).val(val.name);
    };

    return settings;
}

function TownAutocompleteSettings(): object {
    let settings = GetDefaultAutocompleteSettings();
    settings.url = window.ETDR_RD.appConfig["UrlAction.GetTownByName"];
    settings.queryProperty = "term";
    settings.minChars = 2;
    settings.onSelect = function (el, value) {
        $(this).val(value.name);

        // HTML Id for the field containing the Id (db column name) value of the town
        var idForIdField = $(this).data('autocomplete-town-id');

        if (idForIdField) {
            var $idElem = $('#' + idForIdField);

            $idElem.val(value.id);
        }
    };

    return settings;
}

export function InitAutocompletes() {
    autocomplete($, window);

    $('.country-name').tinyAutocomplete(CountrySettings());

    $('.town-name').tinyAutocomplete(TownAutocompleteSettings());

    $('input.nature-of-public-space').tinyAutocomplete(NatureOfPublicSpaceAutocompleteSettings());

    $('input.zip-code').tinyAutocomplete(ZipcodeSettings()).on('receivedata', function (ev, tinyAutocomplete, json) {
        let telepulesNevInput: JQuery<HTMLElement> = $(ev.target).closest('table.form').find('input.settlement-name');
        let telepulesIdInput: JQuery<HTMLElement> = $(ev.target).closest('table.form').find('input.settlement-id');

        if (telepulesNevInput.length === 0) {
            telepulesNevInput = $('input.settlement-name');
        }

        if (telepulesIdInput.length === 0) {
            telepulesIdInput = $('input.settlement-id');
        }

        // tinyAutocomplete.json is the variable that Tiny Autocomplete uses for displaying the options later on
        if (json.length == 1) {
            telepulesNevInput.val(json[0].name);
            telepulesIdInput.val(json[0].id).trigger('change');
        }
        else if (json.length > 1) {
            tinyAutocomplete.json = json;
        }
        else if ($(this).val().toString().length < 4) {
            telepulesNevInput.val('');
            telepulesIdInput.val('').trigger('change');
        }
        else {
            telepulesNevInput.val('Érvénytelen irányítószám!');
            telepulesIdInput.val('').trigger('change');
        }
    });
}

$(function () {
    InitAutocompletes();
});
